export const OnboardingSteps = {
  welcome: 'welcome',
  followArtists: 'follow_artists',
  artPurchasingHistory: 'art_purchasing_history',
  plansOnFairart: 'plans_on_fairart',
} as const

export type OnboardingStep =
  (typeof OnboardingSteps)[keyof typeof OnboardingSteps]

export const ONBOARDING_STEPS_COUNT = 3

export const ONBOARDING_STATUS = {
  NOT_SHOWN: 'NOT_SHOWN',
  SKIPPED: 'SKIPPED',
  INCOMPLETE: 'INCOMPLETE',
  COMPLETED: 'COMPLETED',
}

export const ONBOARDING_EXPERIENCE = {
  NEW: 'NEW',
  INTERMEDIATE: 'INTERMEDIATE',
  EXPERIENCED: 'EXPERIENCED',
}

export const ONBOARDING_INTENT = {
  BUY: 'BUY',
  SELL: 'SELL',
  BUY_SELL: 'BUY_SELL',
}
